import {
  Badge,
  Button,
  Center,
  Flex,
  Heading,
  Image,
  Link,
  Stack,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';
import {  FaYoutube } from "react-icons/fa";


export default function Teacher() {
  const p = [
    { img: "https://user-images.githubusercontent.com/103061012/228313546-bf3c8d35-f049-4230-a649-10a2e10c1f7d.JPG", designation: "HOD OF SBPATHSHALA", des: "hi am teacher of sb" },
   

  ]
  const bgc=useColorModeValue('white', 'gray.900')
  const txc=useColorModeValue('gray.700', 'gray.400')
  const badc=useColorModeValue('gray.50', 'gray.800')
 
  return (
    p.map((obj) => <Center py={6}>
        <Stack
          borderWidth="1px"
          borderRadius="lg"
          w={{ sm: '100%', md: '90vw' }}
          height={{ sm: '800px', md: '20rem' }}
          direction={{ base: 'column', md: 'row' }}
      
          style={{ boxShadow: '0 14px 52px rgba(0, 255, 0, 0.1)' }}
          padding={4}>
          <Flex flex={1} >
            <Image
              objectFit="cover"
              boxSize="100%"
              borderRadius="40px"
              src={
                 obj.img
              }
            />
           
          </Flex>
          <Stack
            flex={1}
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            p={1}
            pt={2}>
            <Heading fontSize={'2xl'} fontFamily={'Arvo'} color='gray'>
              Chandan Prasad
            </Heading>
            <Text fontWeight={500} textAlign={'center'} fontFamily={'Arvo'} color='gray' size="sm" mb={4} >
              HOD OF SB PATHSHALA
            </Text>
            <Text
              textAlign={'center'}
              px={3}
              fontFamily={'Arvo'} color='gray'
              >

I am leading SB Pathshala Coaching Center, where our owner and head of the department excel in preparing students for JEE Main, NEET, Bihar Board, and CBSE exams. We provide specialized instruction in English communication and computer skills.
            
            </Text>
           

            <Stack
              width={'100%'}
              mt={'2rem'}
              direction={'row'}
              padding={2}
              justifyContent={'space-between'}
              alignItems={'center'}>
              <Button
                flex={1}
                fontSize={'sm'}
                rounded={'full'}
                _focus={{
                  bg: 'gray.200',
                }}>

                <Link href={"https://api.whatsapp.com/send?phone=%2B918002152953&data_filter_required=AWB0wjFFxq6XcujMZ0ZnsIOcpiCzoHGjx8RXqiG6RI7xPQ0EJ0e_jY2aUOLlW_WRfJwmoSKRINv0kHKqzxBWwl9AOw_9kjPBRYdUQHwpNWOMQs5yCDq3lmfoV245G_DVo9-cNQpZPxgGxPQix1v6WSRT3fHxd1u6ONlsxl-nbORGNNKsLd2Zuzm6MrhtA9N7X7ONyD2X9KxTgAKNhBa73Sq0gw1bHfZ6_tFKC1gGKWkflgmaXuMoOoUF8Al9AdMnGiJx55zlIHN7h9TQ_Zo46c4R1bkI3NoYAap5CIPF8MXMZagm1Y8&source=FB_Page&app=facebook&entry_point=page_cta&fbclid=IwAR2jqtNaCio3Pk9jQHEAHqi669TvO9t_76rBP-5nz5VvJt6cyRME2qU3X9U"}>Massage</Link>
              </Button>
              <Button
                flex={1}
                fontSize={'sm'}
                rounded={'full'}
                bg={'blue.400'}
                color={'red'}
                boxShadow={
                  '0px 1px 25px -5px rgb(66 153 225 / 48%), 0 10px 10px -5px rgb(66 153 225 / 43%)'
                }
                _hover={{
                  bg: 'white.500',
                }}
                _focus={{
                  bg: 'blue.500',
                }}>

                <Link href={"https://www.youtube.com/@sbpathshala4753/home"}><FaYoutube /></Link>
              </Button>
            </Stack>
          </Stack>
        </Stack>
      </Center>)
   
    

  );
}
